






























import {Component, Vue, Prop } from "vue-property-decorator";

import UsersListItem from '@share/common/users-list/UsersListItem.vue';
import { UserProfile } from "@api/models/UserProfile";
import { MScheduleSlot } from "@api/models/meetings-schedule/MeetingsScheduleSlot";
import { DateTime } from "luxon";
import { dateInOriginalOffset, formatDate } from "@common/dateTimeHelper";

@Component({
    components: { UsersListItem }
})
export default class AppointmentMembers extends Vue {

    @Prop({ default: [] }) profiles: Record<number, UserProfile>;
    @Prop({ default: [] }) slots: MScheduleSlot[];
    @Prop({ default: () => DateTime.local() }) scheduleDate: DateTime;

    getMemberSlotTime(slot: MScheduleSlot) {
        const getTime = (date: DateTime) => {
            return date.toFormat("HH:mm")
        }

        return slot ? getTime((slot.beginAt as DateTime)) + " - " + getTime((slot?.endAt as DateTime)) : ""
    }

    getFormatedDate(date: DateTime | undefined) {
        const today = dateInOriginalOffset(DateTime.local(), this.offset);
        if(date) {
            return formatDate(date, this.lang, date.hasSame(today, 'year'))
        }
        else {
            return ""
        }
    }

    private get lang() {
        return this.$store.state.session.language ?? 'en';
    }

    private get offset() {
        return this.$store.state.timeZoneOffset;
    }
}
